import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { SingService } from '../../service/sing.service';
import { ActivatedRoute } from '@angular/router';
import {Budget} from './services/budget.service'
import { Params } from './class/params';
import { responseListProduct } from 'app/components/class/http/res/response-list-product';
import { updateCategories } from 'app/components/class/broadcaster/update-categories';
@Component({
  selector: 'budget-app',
  templateUrl: 'budget.html',
  styleUrls: ['./budget.component.css'],
  providers: [Budget]
})
export class BudgetComponent {
  data;
  categories;
  dealers;
  stats;
  mainTable;
  subTable;
  fixedHeader;
  mouseMainTable = false;
  date = new Date();
  params:Params = new Params(0,0,0,0);
  typeMonth:boolean = true;
  dealerId;
  width;
  allCategories;
  infoOpen = false;
 
  constructor(
    private httpService: SingService,
    private route: ActivatedRoute,
    private broadcaster: Broadcaster,
    private elementRef: ElementRef,
    private action: Budget,
  ) {
    this.route.queryParams.subscribe(p => {
      this.params.dealerGroupId = p.id;
      this.dealerId = p.id;
    });
    this.getDate();
    this.getData();
    this.broadcaster.broadcast('updateGLMenu', {
      id: this.params.dealerGroupId,
    });
  }
  ngAfterViewInit() {
    this.broadcaster.on<any>('showPreloaderBudget').subscribe(data => {

      //this.elementRef.nativeElement.querySelector('main').style.display = 'none';
        this.elementRef.nativeElement.querySelector('#preloader-budget').style.display = 'block';
    })
    this.width = window.innerWidth;
    let header = document.querySelector('header');
    this.mainTable = document.getElementById('mainTable');
    this.subTable = document.getElementById('subTable');
    this.fixedHeader = document.getElementById('fixedHeader');
    const tableHeading = document.getElementById('fixedHeader');
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      if (this.width - 1061 >= 0) {
        this.fixedHeader.style.left = "350px";
      } else {
        this.fixedHeader.style.left = `${350 - this.width - 1061}px`;
      }
    }
    this.broadcaster.on<any>("updateCategories").subscribe((data:updateCategories) => {
      this.categories = data.categories;
     
  })
    this.broadcaster.on<any>('updateBudgetFromDate').subscribe(data => {
      this.params.updateData(data.data.viewType,this.dealerId,data.data.month,data.data.year,data.quarter);
      this.typeMonth = (data.data.viewType === "daysOfMonth") ? true : false;

      this.getData();
    });
    this.broadcaster.on<any>('updateBudget').subscribe(data => {
      this.getData();
    })
    this.broadcaster.on<any>("openInfoBudget").subscribe(data => {
      this.infoOpen = true;
    })
    this.broadcaster.on<any>("openInfoBudgetNew").subscribe(data => {
      this.infoOpen = true;
    })
    this.broadcaster.on<any>('infoClosed').subscribe(data => {
      this.infoOpen = false;
    })
   
    window.addEventListener('scroll', () => {

      if (window.pageYOffset >= 80 && this.infoOpen === false) {
        header.classList.add('m--fixed');
      } if (window.pageYOffset >= 100 && this.infoOpen === false) {
        tableHeading.classList.remove('hid');
      } else {
        tableHeading.classList.add('hid');
        header.classList.remove('m--fixed')
      }
   
    })
    

    
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
      let width = this.width - 1061;
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        if (width >= 0) {
          this.fixedHeader.style.right = '0px';
        } else {
          this.fixedHeader.style.right = `${this.mainTable.scrollLeft + width}px`;
        }
      } 
    })
  }
  getDate() {
    let settings: any = JSON.parse(window.localStorage.getItem('settings'));
    if (settings === null) {
      settings = { month: new Date().getMonth() + 1, year: new Date().getFullYear(), viewType: 'daysOfMonth', quarter: 0 };
      window.localStorage.setItem('settings', JSON.stringify(settings));
    }
    this.params.updateData(settings.viewType,this.dealerId,settings.month,settings.year,settings.quarter);
    this.typeMonth = (settings.viewType === "daysOfMonth") ? true : false;
  }
  getData() {
    
    this.httpService.getBudgetData(this.params).subscribe(data => {
    
        this.elementRef.nativeElement.querySelector('main').style.display = 'block';
        this.elementRef.nativeElement.querySelector('#preloader-budget').style.display = 'none';
        this.broadcaster.broadcast('updateCategories', new updateCategories (data.data.categories));
      this.categories = data.data.categories;
      this.broadcaster.broadcast("sendBudgetData", {
        data: data.data,
        typeMonth: this.typeMonth,
        date: this.params
      });
      this.data = data.data;
      this.getListData();
    });
  }
  getNewData(event:any) {
    this.httpService.getBudgetData(this.params).subscribe(data => {
      this.ordinal(data.data.categories, this.allCategories);
      data.data.categories.sort(function (a, b) {
        return a.ordinal - b.ordinal
      })
      for (let c of data.data.categories) {
        let index = this.allCategories.findIndex((l) => {
          return l.name == c.title
        })
        if (this.allCategories[index] && c.products.length > 1) {
          this.ordinal(c.products, this.allCategories[index].products);
          c.products.sort((a, b) => {
            return a.ordinal - b.ordinal;
          })
        }
      }
      this.categories = data.data.categories;
      this.elementRef.nativeElement.querySelector('main').style.display = 'block';
      this.elementRef.nativeElement.querySelector('#preloader-budget').style.display = 'none';
      this.broadcaster.broadcast("sendNewBudgetData", {
        data: data.data,
        typeMonth: this.typeMonth,
        date: this.params
      })
    })
  }
  getListData() {
   
    this.httpService.getListProducts(this.params.dealerGroupId)
      .subscribe((data:responseListProduct) => {
        this.allCategories = data.categories;
      
        let mediaCategories = this.action.getMediaCategories(data.categories);
      
        this.broadcaster.broadcast('updateMediaCategories',mediaCategories);
      this.broadcaster.broadcast("updateCategories", new updateCategories (this.categories));
        this.broadcaster.broadcast("allCategories", {
          data: data.categories
        })
        this.ordinal(this.data.categories, data.categories);
        for (let c of this.data.categories) {
          let index = data.categories.findIndex((l) => {
            return l.name == c.title
          });
          if (data.categories[index] && c.products.length > 1) {
            this.ordinal(c.products, data.categories[index].products)
            c.products.sort((a, b) => {
              return a.ordinal - b.ordinal
            })
          }
        }
        this.data.categories.sort(function (a, b) {
          return a.ordinal - b.ordinal;
        });
      })
  }
  ordinal(cat, list) {
    for (let c of cat) {
      c.color = '#000000';
      for (let l of list) {
        if (c.title === l.name) {
          c.color = l.color;
          c.ordinal = l.ordinal;
        }
      }
    }
  }
  theScroll(event:any) {
    let width = this.width - 1061;
   
    if (this.mouseMainTable) {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        this.subTable.scrollLeft = this.mainTable.scrollLeft;
        this.fixedHeader.style.left = `${350 - (this.mainTable.scrollLeft)}px`;
      } else {
        this.subTable.scrollLeft = this.mainTable.scrollLeft;
        this.fixedHeader.style.right = `${(this.mainTable.scrollLeft).toString()}px`;
      }
    } else {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        this.fixedHeader.style.left = `${350 - (this.mainTable.scrollLeft)}px`;
        this.mainTable.scrollLeft = this.subTable.scrollLeft;
      } else {
        this.mainTable.scrollLeft = this.subTable.scrollLeft;
        this.fixedHeader.style.right = `${(this.mainTable.scrollLeft).toString()}px`;
      }
    }
  }
  mouseEvent(e:any, type:string) {
    if (type === 'main') {
      this.mouseMainTable = true;
    } else {
      this.mouseMainTable = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/budget/budget.component.ts